import React from 'react'

export default function ProjectTitle({project}) {
  return (
   <div className="prjdetails-sub-header">
      <nav aria-label="breadcrumb" className="main-breadcrumb">
      <ol className="breadcrumb">
         <li className="breadcrumb-item" aria-current="page">
            <center className="project-all-info">
            {project?.zohoID}-{project?.name}
            </center>
         </li>
      </ol>
      </nav>
   </div>
  )
}
